import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import useTheme from '@mui/material/styles/useTheme';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { formatCompactCurrency } from '../../../../../../../../utils/formatters';

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <Paper sx={{ p: 1.5, boxShadow: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>{label}</Typography>
                {payload.map((entry, index) => (
                    <Typography key={index} variant="body2" sx={{ color: entry.color }}>
                        {entry.name}: {formatCompactCurrency(entry.value)}
                    </Typography>
                ))}
            </Paper>
        );
    }
    return null;
};

const MonthlyRevenueChart = ({ data }) => {
    const theme = useTheme();

    return (
        <Paper sx={{ px: 1, pb: 3, pt: 1, height: 400 }}>
            <Typography variant="h6" component="h2" sx={{ mb: 2, textAlign: 'center', fontWeight: 'medium' }}>
                Monthly Breakdown
            </Typography>
            <ResponsiveContainer width="100%" height="90%">
                <BarChart
                    data={data}
                    margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="monthYear" angle={-45} textAnchor="end" height={50} />
                    <YAxis tickFormatter={formatCompactCurrency} width={100} />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend verticalAlign="bottom" height={36} wrapperStyle={{ paddingTop: '20px' }} />
                    <Bar dataKey="invoice" fill={theme.palette.primary.main} name="Invoice" />
                    <Bar dataKey="product_purchase_cost" fill={theme.palette.error.main} name="Purchase" />
                    <Bar dataKey="margin" fill={theme.palette.success.main} name="Margin" />
                </BarChart>
            </ResponsiveContainer>
        </Paper>
    );
};

export default MonthlyRevenueChart;